<div id="about">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Vice Principal's Message</h4>
                  <div class="card-body text-center">
                    <div class="row ">
                        <div class="col-12 text-center">
                            <img appLazyload src="/assets/img/message/2.jpeg" alt="Principal Message" class="img-fluid rounded">
                        </div>
                    </div>
                     <p class="inner-lead">I feel proud to be a part of this school that aims to introduce value-based quality education to students. I feel that every child is unique with latent qualities. Our teachers do their best to find those qualities and pave the way for a student to develop himself into an
                      impressive personality. Blended efforts of teachers and parents make the student never lose sight of his nurtured dream.
                      </p>
                      <p class="inner-lead">Students also should get the advantage of this opportunity and use their skills to perfection to become ‘winning personalities” and complete human beings. This is possible only if they recognize their latent power of learning with concentration and observation. As the
                        saying goes, ‘Time Once Gone, Never Comes Back’, students should respect the time and utilize it prudently.
                        </p>
                        <p class="inner-lead">Best of Luck with the new session!</p>
                     <p class="inner-lead mb-0">Vice Principal</p>
                     <p class="inner-lead mb-0">Dr. Ravinder Kwatra</p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>